import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ContractTemplateFieldTypeService } from './contract-template-field-type.service';
const service = new ContractTemplateFieldTypeService();

export interface ContractTemplateFieldTypeState {}

const ContractTemplateFieldTypeStore: Module<ContractTemplateFieldTypeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getContractTemplateFieldTypes(context) {
         const response = await service.getContractTemplateFieldTypes();
         return response.data;
      },
   },
};

export default ContractTemplateFieldTypeStore;
